export default __webpack_public_path__ + "asset/img/icon-arrow~20bd25f7.png";